import { render, staticRenderFns } from "./VuePage.vue?vue&type=template&id=b0ac7946&scoped=true&"
import script from "./VuePage.vue?vue&type=script&lang=js&"
export * from "./VuePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ac7946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ac7946')) {
      api.createRecord('b0ac7946', component.options)
    } else {
      api.reload('b0ac7946', component.options)
    }
    module.hot.accept("./VuePage.vue?vue&type=template&id=b0ac7946&scoped=true&", function () {
      api.rerender('b0ac7946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/vueSample/VuePage.vue"
export default component.exports